import { render, staticRenderFns } from "./polar-area.vue?vue&type=template&id=46d3685c&scoped=true"
import script from "./polar-area.vue?vue&type=script&lang=js"
export * from "./polar-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d3685c",
  null
  
)

export default component.exports